export default "__VITE_ASSET__BR7aZ72Z__"